// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3TSyY","dragIcon":"Choice_dragIcon__1sEnP","left":"Choice_left__2GgJA","input":"Choice_input__3vAv0"};